import { z } from 'zod';

import type { ActivityDefinition } from './types.js';

import { draftFields } from './_shared.js';
import { activityIssue, asList } from './types.js';

/**
 * KUI's `MAX_LEARNING_OUTCOMES`. Repeated rather than imported — this package is the
 * browser-safe pure core and reaches into no app — and enforced rather than assumed:
 * a fourth outcome is not rendered, so authoring one silently loses it.
 */
export const MAX_LEARNING_OUTCOMES = 3;

const issue = activityIssue('start_learning_outcomes');

/** The title screen's other face: it lists what the player will learn instead of the cast. */
export const startLearningOutcomes: ActivityDefinition = {
  type: 'start_learning_outcomes',
  summary: 'A title screen listing what the player will learn, finishing when they tap Begin.',
  setup: z.looseObject({
    ...draftFields,
    title: z.string().optional(),
    subtitle: z.string().optional(),
    learningOutcomes: z.array(z.string()).optional(),
  }),
  check: (setup, ctx) => {
    const outcomes = asList(setup.learningOutcomes);
    if (outcomes.length <= MAX_LEARNING_OUTCOMES) {
      return [];
    }
    return [issue(
      'tooManyOutcomes',
      `Only the first ${MAX_LEARNING_OUTCOMES} learning outcomes are rendered; the rest are dropped (got ${outcomes.length}).`,
      [...ctx.path, 'setup', 'learningOutcomes'],
      ctx,
      outcomes.length,
    )];
  },
};
